import script from "./portfolioDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./portfolioDialog.vue?vue&type=script&setup=true&lang=js"

import "./portfolioDialog.vue?vue&type=style&index=0&id=2b45e6ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b45e6ca"]])

export default __exports__